import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { UnownedOwnershipStatuses } from '../../../../config/constants';
import DisplayItems from '../../../../config/details';
import DetailLineItems from './DetailLineItems';
import InfoBox from '../../../common/InfoBox';
import Item from '../../../../models/Item';
import formPropsType from '../../../common/types/formPropsType';
import './Details.css';

class Details extends PureComponent {
  render() {
    const { item, formProps, startInEditMode } = this.props;
    let statusFields =
      UnownedOwnershipStatuses.indexOf(formProps.values.itemData.ownership_status, ) === -1
        ? ['ownership_status', 'location', 'specific_location']
        : ['ownership_status', 'sale_date', 'sale_value'];

    if (item.category === 'BOOK') {
      statusFields = ['ownership_status', 'location', 'specific_location', 'book_location_bookshelf', 'book_location_row', 'book_location_book'];
    }

    let gridClassName;
    if (item.hasDetails() || item.category === 'ART') {
      gridClassName = 'detailsGrid';
    } else {
      gridClassName = 'detailsGridNoDetails';
    }

    let provenanceProperties;
    if (item.category === 'ART') {
      provenanceProperties = ['art_ownership_history', 'ownership_contact', 'art_exhibition_history', 'art_conservation_history', 'art_catalogue_raisonne', 'art_literature'];
    } else {
      provenanceProperties = ['item_history', 'ownership_contact', 'notes'];
    }


    return (
      <div className={gridClassName}>

        {item.hasDetails() && (
        <InfoBox title="Details" className="detailsInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={DisplayItems.details[item.category]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />
          </dl>
        </InfoBox>
      )}


        {item.hasArtist() && (
        <InfoBox title="Artist" className="detailsInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={[
                'art_artist_bibliography',
                'art_artist_cv',
                'art_artist_awards',
              ]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />
          </dl>
        </InfoBox>
      )}

        <InfoBox title="Provenance" className="provenanceInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={provenanceProperties}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />
          </dl>
        </InfoBox>
        <InfoBox title="Description" className="descriptionInfoBox">
          <DetailLineItems
            item={item}
            properties={['description']}
            formProps={formProps}
            startInEditMode={startInEditMode}
          />
        </InfoBox>

        <InfoBox title="Status" className="statusInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={statusFields}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />
          </dl>
        </InfoBox>
      </div>
    );
  }
}

Details.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  formProps: formPropsType.isRequired,
  startInEditMode: PropTypes.bool,
};

Details.defaultProps = {
  startInEditMode: false,
};

export default Details;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Details.jsx